<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <div class="input-group">
        <b-form-radio-group :options="['Tubes', 'Trays', 'Reels','Bags', 'Other']" v-model="model.packaging_ShippedIn">
          <span class="col-form-label">Parts Shipped In</span>
        </b-form-radio-group>  
        <b-form-input type="text" class="col-3 ml-2" placeholder="Other" v-if="model.packaging_ShippedIn == 'Other'" v-model="model.packaging_ShippedInOther"></b-form-input>
      </div>
      

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.packaging_OriginalPackaging"
      >
        <span
          class="col-form-label"
        >Are the parts in factory-original packaging (factory-issued tubes, reels, trays?)</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_SealedBags">
        <span class="col-form-label">Are the parts’ packages in sealed bags?</span>
      </b-form-radio-group>

      <div class="input-group">
        <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_PartsMoistureSensitive">
          <span class="col-form-label">Are parts moisture sensitive?</span>
        </b-form-radio-group>
        <b-form-select class="col-1 ml-2" placeholder="Sensitivity" v-if="model.packaging_PartsMoistureSensitive == 'Yes'" v-model="model.packaging_PartsContaminationFreeSensitivityLevel" 
        :options="[{text: 'MSL Level', value: null, disabled: true}, 'MSL Level 1', 'MSL Level 2', 'MSL Level 3', 'MSL Level 4', 'MSL Level 5', 'MSL Level 6']"></b-form-select>  
      </div>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_PartsVacuumSealedBags" v-if="model.packaging_PartsMoistureSensitive == 'Yes'">
        <span class="col-form-label">Are parts in vacuum sealed bags?</span>
      </b-form-radio-group>
      <div class="input-group" v-if="model.packaging_PartsMoistureSensitive == 'Yes'">
        <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_BagOpenedForVerify" >
          <span class="col-form-label">Did you open a bag to verify if parts were packaged with proper desiccant and indicator card? If no, report why.</span>
        </b-form-radio-group>
        <b-form-input type="text" class="col-4 ml-2" v-model="model.packaging_BagOpenedForVerifyReason"></b-form-input>
      </div>

      <div class="input-group" v-if="model.packaging_PartsMoistureSensitive == 'Yes'">
        <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_PartsContaminationFree" >
          <span class="col-form-label">Did the indicator card show that the parts are free from contamination? Please record your findings</span>
        </b-form-radio-group>
        <b-form-input type="text" class="col-3 ml-2" v-model="model.packaging_PartsContaminationFreeFindings"></b-form-input>
        
      </div>
      
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.packaging_FactoryVacuumBags"
      >
        <span class="col-form-label">Are the parts in factory-sealed (vacuum) packaging?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_FactoryLabel">
        <span class="col-form-label">If in factory bags, are there factory labels?</span>
      </b-form-radio-group>

      <div class="input-group">
        <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_ESDCompliant">
          <span class="col-form-label">Are the parts in ESD Compliant packaging? Please record your findings. </span>
        </b-form-radio-group>  
        <b-form-input type="text" class="col-4 ml-2" v-model="model.packaging_ESDCompliantFindings"></b-form-input>
      </div>
      
      <b-form-group label="">
        
      </b-form-group>  

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.packaging_PartsFactorySealedBag"
      >
        <span class="col-form-label">Are parts in factory sealed bags?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_BagsVacuumSealed" v-if="model.packaging_PartsFactorySealedBag == 'No'">
        <span class="col-form-label">Are bags vacuum sealed?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_FactoryBagsWithLabel" v-if="model.packaging_PartsFactorySealedBag == 'No'">
        <span class="col-form-label">If factory bags, is there a label?</span>
      </b-form-radio-group>

      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.packaging_HolesInBag">
        <span class="col-form-label">Are there any visual tears or punctured holes in the packaging?</span>
      </b-form-radio-group>

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.packaging_PackageInGoodCond"
      >
        <span class="col-form-label">Is the carrier (tube, reel, tray) in good condition?</span>
      </b-form-radio-group>

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.packaging_AgeConditionConsistent"
      >
        <span class="col-form-label">Are the parts in packaging consistent with their age and condition?</span>
      </b-form-radio-group>

      <div class="input-group">
        <b-form-input type="text" class="col-1 mr-2"  v-model="model.packaging_NumberNonConform"></b-form-input>
        <b-form-group>
          <span class="col-form-label">No. of non-conformities</span>
        </b-form-group>
      </div>

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.packaging_PhotosTaken"
      >
        <span class="col-form-label">Did you take digital photos of all the packaging?</span>
      </b-form-radio-group>

      <b-form-group label="Please note any other findings">
        <b-textarea type="text" v-model="model.packaging_OtherFindings"></b-textarea>
      </b-form-group>
      
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'aegisPackaging',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        packaging_OriginalPackaging: this.inspectionDetails[FIELDS.PACKAGING__ORIGINAL_PACKAGING] || '',
        packaging_SealedBags: this.inspectionDetails[FIELDS.PACKAGING__SEALED_BAGS] || '',
        packaging_FactoryVacuumBags: this.inspectionDetails[FIELDS.PACKAGING__FACTORY_VACUUM_BAGS] || '',
        packaging_FactoryLabel: this.inspectionDetails[FIELDS.PACKAGING__FACTORY_LABEL] || '',
        packaging_HolesInBag: this.inspectionDetails[FIELDS.PACKAGING__HOLES_IN_BAG] || '',
        packaging_PackageInGoodCond: this.inspectionDetails[FIELDS.PACKAGING__PACKAGE_IN_GOOD_COND] || '',
        packaging_ShippedIn: this.inspectionDetails[FIELDS.PACKAGING__SHIPPED_IN] || '',
        packaging_ShippedInOther: this.inspectionDetails[FIELDS.PACKAGING__SHIPPED_IN_OTHER] || '',
        packaging_ESDCompliant: this.inspectionDetails[FIELDS.PACKAGING__ESD_COMPLIANT] || '',
        packaging_ESDCompliantFindings: this.inspectionDetails[FIELDS.PACKAGING__ESD_COMPLIANT_FINDINGS] || '',
        packaging_AgeConditionConsistent: this.inspectionDetails[FIELDS.PACKAGING__AGE_CONDITION_CONSISTENT] || '',
        packaging_NumberNonConform: this.inspectionDetails[FIELDS.PACKAGING__NUMBER_NON_CONFORM] || '',
        packaging_PhotosTaken: this.inspectionDetails[FIELDS.PACKAGING__PHOTOS_TAKEN] || '',
        packaging_PartsMoistureSensitive: this.inspectionDetails[FIELDS.PACKAGING__PARTS_MOISTURE_SENSITIVE] || '',
        packaging_PartsVacuumSealedBags: this.inspectionDetails[FIELDS.PACKAGING__PARTS_VACUUM_SEALED_BAGS] || '',
        packaging_BagOpenedForVerify: this.inspectionDetails[FIELDS.PACKAGING__BAG_OPENED_FOR_VERIFY] || '',
        packaging_BagOpenedForVerifyReason: this.inspectionDetails[FIELDS.PACKAGING__BAG_OPENED_FOR_VERIFY_REASON] || '',
        packaging_PartsContaminationFree: this.inspectionDetails[FIELDS.PACKAGING__PARTS_CONTAMINATION_FREE] || '',
        packaging_PartsContaminationFreeFindings: this.inspectionDetails[FIELDS.PACKAGING__PARTS_CONTAMINATION_FREE_FINDINGS] || '',
        packaging_PartsContaminationFreeSensitivityLevel: this.inspectionDetails[FIELDS.PACKAGING__PARTS_CONTAMINATION_FREE_SENSITIVITY_LEVEL] || null,
        packaging_PartsFactorySealedBag: this.inspectionDetails[FIELDS.PACKAGING__PARTS_FACTORY_SEALED_BAG] || '',
        packaging_BagsVacuumSealed: this.inspectionDetails[FIELDS.PACKAGING__BAGS_VACUUM_SEALED] || '',
        packaging_FactoryBagsWithLabel: this.inspectionDetails[FIELDS.PACKAGING__FACTORY_BAGS_WITH_LABEL] || '',
        packaging_OtherFindings: this.inspectionDetails[FIELDS.PACKAGING__OTHER_FINDINGS] || ''
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>